import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faBellSlash } from '@fortawesome/free-solid-svg-icons';

const PUBLIC_VAPID_KEY = 'BABxXQ11NbIbL1kthTGTu41l7xm0pN_auepgKK1kD0NXMFGK03d_JIfvUhDABv7yA6Q_NEvqEUroFpTKtaFVvw8';
// console.log('PUBLIC_VAPID_KEY:', PUBLIC_VAPID_KEY);

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

const PushNotification = ({ userId }) => {
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    const checkSubscription = async () => {
      const registration = await navigator.serviceWorker.getRegistration();
      const subscription = await registration?.pushManager.getSubscription();
      setIsSubscribed(!!subscription);
    };

    checkSubscription();
  }, []);

  const subscribeUser = async (registration) => {
    try {
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(PUBLIC_VAPID_KEY),
      });

      await fetch('/Acution/subscribe', {
        method: 'POST',
        body: JSON.stringify({ user_id: userId, subscription }),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      setIsSubscribed(true);
    } catch (error) {
      console.error('Subscription error:', error);
    }
  };

  const unsubscribeUser = async () => {
    const registration = await navigator.serviceWorker.getRegistration();
    const subscription = await registration?.pushManager.getSubscription();
    if (subscription) {
      await subscription.unsubscribe();
      await fetch('/Acution/unsubscribe', {
        method: 'POST',
        body: JSON.stringify({ user_id: userId, endpoint: subscription.endpoint }),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      setIsSubscribed(false);
    }
  };

  const handleSubscribeClick = async () => {
    const registration = await navigator.serviceWorker.register('/service-worker.js');
    await subscribeUser(registration);
  };

  return (
    <div>
      {isSubscribed ? (
        <button onClick={()=>unsubscribeUser()}>
          <FontAwesomeIcon icon={faBellSlash} style={{ marginRight: '8px' }} />
          알림 끄기
        </button>
      ) : (
        <button onClick={()=>handleSubscribeClick()}>
          <FontAwesomeIcon icon={faBell} style={{ marginRight: '8px' }} />
          알림 켜기
        </button>
      )}
    </div>
  );
};

export default PushNotification;